import { LogStep } from 'store/ducks/logs'

export type StateLogsParams = { id: number; step: LogStep }

export const getStateLogsByDelivery = ({ id, step }: StateLogsParams) => {
  return {
    url: `/api/state_logs?deliveryId=${id}&step=${step}`,
    method: 'GET',
    headers: {
      Accept: 'application/ld+json',
      Authorization: null,
    },
  }
}
